/**
 * La conversation avec l'agent, le temps de la session.
 *
 * En mémoire seulement : fermer le panneau ne la perd pas, recharger la page
 * si. Une mémoire durable, par entreprise, est l'étape suivante de la
 * phase 5 — et elle vivra en base, pas dans le navigateur, pour suivre le
 * patron d'un appareil à l'autre.
 */
import { create } from "zustand";
import type { AgentProposal } from "@dker/core";

export interface AgentTurn {
  id: string;
  role: "patron" | "agent";
  text: string;
  /** Côté agent : ce qu'il a écrit, et ce qu'il attend qu'on valide. */
  writes?: string[];
  proposals?: AgentProposal[];
  toolsUsed?: string[];
  failed?: boolean;
}

interface AgentState {
  open: boolean;
  turns: AgentTurn[];
  setOpen: (open: boolean) => void;
  push: (turn: Omit<AgentTurn, "id">) => void;
  reset: () => void;
}

export const useAgentStore = create<AgentState>((set) => ({
  open: false,
  turns: [],
  setOpen: (open) => set({ open }),
  push: (turn) =>
    set((s) => ({ turns: [...s.turns, { ...turn, id: crypto.randomUUID() }] })),
  reset: () => set({ turns: [] }),
}));
